import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Select, Button, Form, Col, Row, message } from 'antd';
import UnionSearch from 'Components/union/unionSearch';
import tQuestionStudyActions from 'Actions/ai/questionStudy';
import { translateObjToString } from 'Utils';
import './index.less';

const FormItem = Form.Item;
const { Option } = Select;

class Search extends UnionSearch {
  constructor(props) {
    super(props);

    this.state = {
      fields: {},
    };
  }

  componentDidMount() {
    const { actions } = this.props;

    // 获取话术名称下拉框
    actions.getWordStrategyIdOptions();
  }

  // 点击查询
  handleFilter = () => {
    const { form } = this.props;
    const fields = form.getFieldsValue();
    this.setState({ fields });
    this.onOk(fields);
  };

  // 导出
  export = () => {
    const { form } = this.props;
    const wordStrategyId = form.getFieldValue('wordStrategyId');
    if (!wordStrategyId) {
      message.error('请先选择话术名称！');
      return;
    }
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;
    const params = {
      vccId,
      wordStrategyId,
    };
    const urlParmasStr = translateObjToString(params);
    window.location.href = `/robot/unknown/question/export${urlParmasStr}`;
  };

  render() {
    const {
      wordStrategyIdOptions,
      searchData: { wordStrategyId },
      form: { getFieldDecorator },
      login
    } = this.props;

    return (
      <Form layout="inline" className="ai-question-study">
        <Row>
          <Col span={6}>
            <FormItem label="话术名称">
              {getFieldDecorator('wordStrategyId', {
                initialValue: parseInt(wordStrategyId, 10),
              })(
                <Select
                  placeholder="请选择"
                  style={{width:330}}>
                  <Option value={0}>请选择</Option>
                  {Array.isArray(wordStrategyIdOptions)
                    ? wordStrategyIdOptions.map(
                      ({ id = '', strategyName = '' }) => (
                        <Option value={id && parseInt(id, 10)} key={id}>
                          {strategyName}
                        </Option>
                      ),
                    )
                    : null}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={6} style={{ lineHeight: '40px' }}>
            <Button
              type="primary"
              onClick={this.handleFilter}
              style={{ margin: '0 10px' }}>
              查询
            </Button>
            {
              login.permissionsList.includes('questionStudy.export') ?
                <Button onClick={this.export}>导出</Button>
                : null}
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = ({ aiQuestionStudy, login }) => ({
  wordStrategyIdOptions: aiQuestionStudy.wordStrategyIdOptions,
  searchData: aiQuestionStudy.searchData,
  pageStatus: aiQuestionStudy.pageStatus,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tQuestionStudyActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(Search));
